import { lazy } from 'react';

export const StravaImportListPage = lazy(() => import('./controller.js'));
